export default {
  GALLERY: "gallery",
  STORY: "story",
  HIGHLIGHT: "highlight",
  IMAGE_UPLOAD: "image_upload",
  SHOP_THE_LOOK: "shop_the_look",
  IMAGE_COLLAGE: "shop_the_look",
  FASHIONS_LIST: "fashions_list",
  MARKETPLACE_REVIEW: "marketplace_review",
};
